module.exports = __webpack_public_path__ + "static/media/02.332477a0.mp3";